export async function copyTextToClipboard(text: string): Promise<boolean> {
	if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text)
		return true
	}

	if (typeof document === "undefined") {
		return false
	}

	const textArea = document.createElement("textarea")
	textArea.value = text
	textArea.setAttribute("readonly", "true")
	textArea.style.position = "absolute"
	textArea.style.left = "-9999px"
	document.body.appendChild(textArea)
	textArea.select()

	try {
		return document.execCommand("copy")
	} finally {
		document.body.removeChild(textArea)
	}
}
